import React, { useEffect, useState } from 'react';
import { Modal, Title, CardTextButtons } from '@gerdau/hefesto';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import NavegationMenuBar from '../../../components/NavegationMenuBar';
import { ERoutes } from '../../../routes';
import { ApplicationState } from '../../../store';
import { cleanFabricationPurchaseOrderSettings } from '../../../store/ducks/fabrication-purchase-order/actions';
import {
  cleanShoppingCart,
  setTaggingInfoPreviousScreen
} from '../../../store/ducks/long-steel-shopping-cart/actions';
import { sendTagging } from '../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../utils/Tagging';
import { EPurchaseRoutes } from '../purchase.routes';
import { Container } from './styles';
import { EOrderSettingsRoutes } from '../LongSteel/OrderSettingsMvp/orderSettings.routes';
import { ordersType } from '../../../store/ducks/long-steel-orders/types';
import { ECustomerTypeView } from '../../../store/ducks/user/types';
import useIsBusinessTypeCG from '../../../hooks/useIsBusinessTypeCG';

const SteelTypeChoose: React.FC = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const shoppingCartItems = useSelector(
    (appState: ApplicationState) => appState.longSteelShoppingCart.items
  );
  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );
  const hasLongSteelPurchaseOrderInProgress: boolean =
    shoppingCartItems.length > 0;
  const [
    canShowLongSteelOrderInProgressModal,
    setCanShowLongSteelOrderInProgressModal
  ] = useState(false);

  const fabricationPurchaseOrder = useSelector(
    (appState: ApplicationState) => appState.fabricationPurchaseOrder
  );
  const hasFabricationOrderInProgress: boolean =
    fabricationPurchaseOrder.constructionIdentification.contractNumber !==
      undefined ||
    fabricationPurchaseOrder.constructionIdentification.orderNumber !== '' ||
    fabricationPurchaseOrder.constructionIdentification.desiredDate !==
      undefined;
  const [
    canShowFabricationOrderInProgressModal,
    setCanShowFabricationOrderInProgressModal
  ] = useState(false);

  const { screenName } = getTaggingInformationScreen(
    window.location.pathname,
    true
  );

  const itemsNavBar = [{ name: 'Comprar', url: pathname }];

  const goToLongSteel = () => {
    prepareAndSendTagging(
      'button:comprar_acos_longos',
      'comprar_comprarAcosLongos'
    );
    history.push(`${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}`);
  };

  const goToFabrication = (subroute = '') => {
    prepareAndSendTagging(
      'button:solicitar_corteDobra',
      'comprar_solicitarCorteEDobra'
    );
    history.push(
      `${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}${subroute}`
    );
  };

  const prepareAndSendTagging = (itemName: string, itemDescription: string) => {
    dispatch(
      sendTagging({
        screenName: screenName,
        event: 'click',
        itemName: itemName,
        itemDescription: itemDescription,
        page: window.location.pathname
      })
    );
  };

  useEffect(() => {
    if (!customersState.loading) {
      dispatch(
        sendTagging({
          screenName: screenName,
          event: 'page_view',
          page: window.location.pathname
        })
      );
    }
  }, [dispatch, screenName]);

  const onClickBuyFabrication = () => {
    if (hasFabricationOrderInProgress) {
      setCanShowFabricationOrderInProgressModal(true);
    } else {
      goToFabrication();
    }
  };

  const onNewOrderClick = () => {
    if (hasFabricationOrderInProgress) {
      dispatch(cleanFabricationPurchaseOrderSettings());
      goToFabrication();
    } else if (hasLongSteelPurchaseOrderInProgress) {
      dispatch(cleanShoppingCart());
      goToLongSteel();
    }
  };

  const onContinueOrderClick = () => {
    if (canShowFabricationOrderInProgressModal) {
      goToFabrication();
    } else if (canShowLongSteelOrderInProgressModal) {
      goToLongSteel();
    }
  };

  const auxScreenName: ordersType = {
    'search-items': 'SelecaoItens',
    'repeat-order': 'RefazerPedido',
    'spreadsheet-upload': 'PedidoViaPlanilha'
  };

  const auxItemDescription: ordersType = {
    'search-items': 'selecaoItens',
    'repeat-order': 'refazerPedido',
    'spreadsheet-upload': 'pedidoViaPlanilha'
  };

  const redirectTo = (orderSettingsRoute: EOrderSettingsRoutes) => {
    dispatch(
      setTaggingInfoPreviousScreen({
        screenName: auxScreenName[orderSettingsRoute],
        itemDescription: auxItemDescription[orderSettingsRoute]
      })
    );
    history.push(
      `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}/${orderSettingsRoute}`
    );
  };

  const customerViewType = useSelector(
    (appState: ApplicationState) => appState.user.searchCustomerType
  );
  const isEmitter = customerViewType === ECustomerTypeView.EMITTER;
  const isBusinessTypeCG = useIsBusinessTypeCG();

  const hasUserFabricationAccess = useSelector(
    (appState: ApplicationState) =>
      appState.user.userPermissions.hasFabricationAccess
  );

  return (
    <Container>
      <header>
        <NavegationMenuBar items={itemsNavBar}></NavegationMenuBar>
        <Title level={1}>Comprar aços</Title>
        <span>Selecione como você deseja comprar produtos ou serviços.</span>
      </header>
      <div className="cards">
        {isEmitter && !isBusinessTypeCG && (
          <>
            <div className="subtitle-cards">
              <Title level={2}>Aços longos</Title>
            </div>
            <div className="cards-container">
              <div className="card">
                <CardTextButtons
                  title="Comprar selecionando itens"
                  description="Selecione e compre seus produtos pelos códigos de SKU ou descrição do material."
                  buttonProps={{
                    label: 'Comprar selecionando itens',
                    onClick: () => {
                      dispatch(
                        sendTagging({
                          screenName: screenName,
                          event: 'click',
                          itemName: 'button:comprarSelecionandoItens',
                          itemDescription:
                            'comprar_acosLongos_refazerPedido_selecao_comprarSelecionandoItens'
                        })
                      );
                      redirectTo(EOrderSettingsRoutes.SEARCH_ITEMS);
                    }
                  }}
                />
              </div>
              <div className="card">
                <CardTextButtons
                  title="Comprar por planilha"
                  description="Preencha e envie uma planilha com os dados dos produtos desejados para montar o seu carrinho."
                  buttonProps={{
                    label: 'Comprar por planilha',
                    onClick: () => {
                      dispatch(
                        sendTagging({
                          screenName: screenName,
                          event: 'click',
                          itemName: 'button:comprarViaPlanilha',
                          itemDescription:
                            'comprar_acosLongos_refazerPedido_selecao_comprarViaPlanilha'
                        })
                      );
                      redirectTo(EOrderSettingsRoutes.SPREADSHEET_UPLOAD);
                    }
                  }}
                />
              </div>
              <div className="card">
                <CardTextButtons
                  title="Com base no histórico"
                  description="Selecione um pedido já realizado e adicione ou remova itens para completar sua compra."
                  buttonProps={{
                    label: 'Comprar com base no histórico',
                    onClick: () => {
                      dispatch(
                        sendTagging({
                          screenName: screenName,
                          event: 'click',
                          itemName: 'button:comprarBaseHistorico',
                          itemDescription:
                            'comprar_acosLongos_comprarBaseHistorico'
                        })
                      );
                      redirectTo(EOrderSettingsRoutes.REPEAT_ORDER);
                    }
                  }}
                />
              </div>
            </div>
          </>
        )}

        {hasUserFabricationAccess && (
          <>
            <div className="subtitle-cards">
              <Title level={2}>Corte e dobra</Title>
            </div>
            <div className="cards-container">
              <div className="card">
                <CardTextButtons
                  title={'Corte e dobra'}
                  description={
                    'Aços longos cortados e dobrados conforme meus projetos.'
                  }
                  buttonProps={{
                    label: 'Solicitar corte e dobra',
                    onClick: onClickBuyFabrication
                  }}
                />
              </div>

              <div className="card">
                <CardTextButtons
                  title={'Revisar pedido por histórico'}
                  description={
                    'Revise seus pedidos de aços cortados e dobrados a partir do seu histórico de compra.'
                  }
                  buttonProps={{
                    label: 'Revisar pedido por histórico',
                    onClick: () => {
                      goToFabrication(
                        `/${EPurchaseRoutes.FABRICATION_REVIEW_ORDER}`
                      );
                    }
                  }}
                />
              </div>
            </div>
          </>
        )}
      </div>

      {(canShowFabricationOrderInProgressModal ||
        canShowLongSteelOrderInProgressModal) && (
        <Modal
          title="Deseja continuar seu último pedido?"
          onClose={() => {
            setCanShowLongSteelOrderInProgressModal(false);
            setCanShowFabricationOrderInProgressModal(false);
          }}
          buttons={{
            left: {
              children: 'Novo pedido',
              name: 'novo-pedido',
              onClick: onNewOrderClick,
              type: 'button'
            },
            right: {
              children: 'Continuar pedido',
              name: 'continuar-pedido',
              onClick: onContinueOrderClick,
              type: 'button'
            }
          }}
          modalSize="sm"
        >
          <span>
            Você possui um pedido em andamento. Para retomar sua compra de onde
            parou clique em continuar pedido.
          </span>
        </Modal>
      )}
    </Container>
  );
};

export default SteelTypeChoose;
